// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2PqVO","name":"Header_name__3Zn9S","birthday":"Header_birthday__30xh5","skeleton":"Header_skeleton__3FXDG"};